import SignIn from "../ui/apps/user/signin";
import Forgot from "../ui/apps/user/forgot";
import Registration from "../ui/apps/user/registration";
import Activation from "../ui/apps/user/activation";
import UserDecide from "../ui/apps/user/decide";
import Complete from "../ui/apps/user/signin";
import UpdatePassword from "../ui/apps/user/update-password";
import Terms from "../ui/apps/user/terms";
import VerifyEmail from "../ui/apps/user/verify";
import UserCheck from "../ui/apps/user/check";

const UserRoutes = [
  {
    path: "/user/signin",
    component: SignIn,
    skipAll: true,
    alohomoraRoute: true
  },
  { path: "/user/forgot", component: Forgot, skipAll: true },
  {
    path: "/user/registration",
    component: Registration,
    skipAll: true,
    skipRedirect: true,
    alohomoraRoute: true
  },
  {
    path: "/user/activation",
    component: Activation,
    skipAll: true,
    alohomoraRoute: true
  },
  {
    path: "/user/sso",
    component: UserDecide,
    skipSSO: true,
    skipTOS: true,
    skipRedirect: true,
    skipReadOffline: true,
    skipVerifyEmail: true,
    skipOnboarding: true,
    alohomoraRoute: true
  },
  {
    path: "/user/decide",
    component: UserDecide,
    skipSSO: true,
    skipTOS: true,
    skipRedirect: true,
    skipReadOffline: true,
    skipVerifyEmail: true,
    skipOnboarding: true,
    alohomoraRoute: true
  },
  // Registration but already has email and signed in (probably need to respect email locked)
  {
    path: "/user/complete",
    component: Complete,
    skipSSO: true,
    skipTOS: true,
    skipRedirect: true,
    skipReadOffline: true,
    skipVerifyEmail: true,
    skipOnboarding: true,
    alohomoraRoute: true
  },
  {
    path: "/user/update-password",
    component: UpdatePassword,
    skipRedirect: true,
    skipReadOffline: true,
    skipVerifyEmail: true,
    skipOnboarding: true,
    alohomoraRoute: true
  },
  {
    path: "/user/terms",
    component: Terms,
    skipTOS: true,
    skipSSO: true,
    skipRedirect: true,
    skipReadOffline: true,
    skipVerifyEmail: true,
    skipOnboarding: true,
    alohomoraRoute: true
  },
  {
    path: "/verify",
    component: VerifyEmail,
    skipTOS: true,
    skipSSO: true,
    skipRedirect: true,
    skipReadOffline: true,
    skipVerifyEmail: true,
    skipAll: true,
    skipOnboarding: true,
    alohomoraRoute: true
  },
  {
    path: "/user/check",
    component: UserCheck,
    skipOnboarding: true,
    skipReadOffline: true,
    alohomoraRoute: true
  }
];

export default UserRoutes;
